<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper page_to_up">
      <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
      <admin-sidebar-menu v-if="((admin === true) || ($store.state.switch_admin_username))" />
        <div class="content-wrapper">
        <div class="container-wrapper center">
        <div class="modal-custom" v-show="showOverlay">
          <div class="loader-img-center">
            <i class="fa fa-spinner fa-spin"></i> Please wait...
          </div>
        </div>
          <div>
            <h3 class="d-inline heading">Certification Manager</h3>
            <button
                v-on:click="isModalVisible = true, verrors.clear(), image = ''"
                class="btn btn-red btn-md input-height-15 float-right text-align-right"
                ><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Certification</button>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div
              class="col-lg-3 col-md-12 col-12"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Title"
              @keyup.enter="filterCertificationitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-2 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="status_options"
                @change="filterCertificationitems()"
              >
              </b-form-select>
            </div>
            <div v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" class="col-lg-3 col-md-10 col-10">
               <b-form-select
                class="input-text"
                v-model="search_affiliate"
                :options="affiliate_options"
                @change="filterCertificationitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5">
               <b-form-select
                class="input-text"
                v-model="search_user"
                :options="user_options"
                @change="filterCertificationitems()"
              >
              </b-form-select>
            </div>
            <div class="col-lg-1 col-md-2 col-2 search-icon-wrapper cursor-pointer" @click="filterCertificationitems()">
            <span class="search-icon">
              <i class="fa fa-search"></i>
            </span>
            </div>
            <div class="col-lg-1 col-md-2 col-2 scroll_box cursor-pointer">
              <span class="scroll_up_down" @click="scrollToElement('down')">
                <i class="fa fa-angle-down angle_font"></i>
              </span>
            </div>
          </div>
          </div>
          </b-collapse>
        </b-navbar>
      </div>
          <div class="margin-bottom-10"></div>
          <div>
             <b-card no-body>
                 <div class="row tasks_heading_row">
                   <div
                     class="bold cursor-pointer col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"
                     v-on:click="sortMethod('certificateName')"
                     >
                     Title
                     <i v-if="publicSortField == 'certificateName' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'certificateName' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding"
                     v-on:click="sortMethod('status')"
                     >
                     Status
                     <i v-if="publicSortField == 'status' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'status' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                     >
                     Affiliate
                     <i v-if="publicSortField == 'affiliate_name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'affiliate_name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding"
                     v-on:click="sortMethod('createdBy')"
                     >
                     Created By
                     <i v-if="publicSortField == 'createdBy' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'createdBy' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                     v-on:click="sortMethod('certificateOrganization')"
                     >
                     Organization
                     <i v-if="publicSortField == 'certificateOrganization' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="publicSortField == 'certificateOrganization' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>

                 </div>

                  <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                   <b-card-text v-if="certification_lists.length > 0">
                      <div class="tasklists-row" v-for="(list, index) in certification_lists">
                      <div class="row tasklist-item" style="margin: 0;">
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                          {{list.certificateName}}
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 override-padding">{{getStatus(list.status)}}</div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">{{list.affiliate_name}}</div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-3 override-padding">{{list.created_by}}</div>
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">{{list.certificateOrganization}}</div>
                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 override-padding">
                            <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')">
                            <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index">
                              <li></li>
                              <li></li>
                              <li></li>
                            </ul>
                            <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                              <div class="action-dd-menu" @click="getCertificationDetails(list.id)"><i class="cursor-pointer fa fa-edit spacer-icon" ></i>Edit</div>
                              <div class="action-dd-menu" v-if="(list.status=='DRAFT')" @click="updateCertificateStatus(list.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                              <div class="action-dd-menu"  v-if="((list.status=='DRAFT' || list.status=='DEACTIVATED'))" @click="deleteCertificateConfirm(list.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                              <div class="action-dd-menu" v-if="(list.status=='PUBLISH')" @click="deactivateCertificateConfirm(list.id, list.name)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>
                            </div>
                            </div>
                        </div>
                      </div>
                      <div><hr></div>
                      </div>
                      <div class="row page_to_down">
                        <div class="mx-auto">
                          <div class="overflow-auto m-3">
                            <b-pagination v-if="rows > 25"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"
                              v-bind:hide-goto-end-buttons=true
                              @input="showTasklistofPaginated()"
                            ></b-pagination>
                          </div>
                        </div>
                        <div class="page_angle_down">
                          <div class="scroll_box cursor-pointer">
                            <span class="scroll_up_down" @click="scrollToElement('up')">
                              <i class="fa fa-angle-up angle_font"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                   </b-card-text>
                   <b-card-text v-else-if="loading == false">
                        No certification matches your search.
                   </b-card-text>
             </b-card>
         </div>
      </div>


      <CreateCertificateModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading" style="color: #00"><h3>Add Certification</h3></div>
        <div slot="body"  v-if="isModalVisible == true">
          <div class="col-12 override-padding">
            <input v-model="certification_name"
                  name="certification_name"
                  placeholder="Enter Certification Name"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('certification_name', 'required')" class="margin-bottom-5 validate-warning-msg">Certification Name is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="certificate_organization"
                  name="certificate_organization"
                  placeholder="Certificate Organization"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('certificate_organization', 'required')" class="margin-bottom-5 validate-warning-msg">Certificate Organization is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" style="display:flex;">
            <div 
              class="search-padd" 
              id="affliate-wrapper" 
              style="height: 30px;width: 100%;">
              <multiselect v-model="affiliate"
                :options="affiliate_options"
                track-by="value"
                label="text"
                placeholder="Select Affiliate"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                v-bind:name="'affiliate[]'"
                v-bind:id="'affiliate'"
                v-validate="'required'">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              </multiselect>
            </div>
          </div>
          <div v-if="verrors.firstByRule('affiliate[]', 'required')" class="validate-warning-msg" style="margin-top: 15px;">Affiliate is required</div>
          <div v-else class="validate-warning-msg" style="margin-top: -5px;">&nbsp;</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="certification_link"
                  name="certification_link"
                  placeholder="Certification Link or Registration Link"
                  class="col-lg-12 input-height-25 input-class"
                  maxlength="255" />
            <div v-if="verrors.has('certification_link')" class="margin-bottom-5 validate-warning-msg">Link is invalid</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>

          <div class="col-12 override-padding">
            <input 
              @change="handleImage"
              type="file" 
              name="image_file"
              ref="image_file"
              v-validate="'required'"
              accept="image/*"
              rules="required"
              class="input-file"  >
            <div v-if="verrors.firstByRule('image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Logo is required</div>
            <div class="help-text">Logo should be jpg, jpeg, gif, png and size should be of 2MB</div>
            <div style="clear: both;" class="margin-bottom-10"></div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <div class="col-9 float-left p-0 text-center" style="border: 1px solid #707070; height: 100px; width: 250px;" v-if="image">
              <img :src="image" width="100" height="85" style=" padding-top: 10px;" />
            </div>
            <div class="col-9 float-left p-0" style="border: 1px solid #707070; height: 100px; width: 250px; text-align: center; padding-top: 35px !important;"  v-else>
              Logo Example
            </div>
            <div class="col-3 text-align-right float-right p-0" style="margin-right: 0px; margin-top: 60px;">
              <button
                  v-on:click="createCertificate()"
                  class="btn btn-red col-lg-12 input-height-25 createBtn"
                  ><b>Create</b></button>

            </div>            
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </CreateCertificateModal>


      <EditCertificateModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"><h3>Edit Certification</h3></div>
        <div slot="body" v-if="isEditModalVisible == true">
          <div class="col-12 override-padding">
            <input v-model="edit_certification_name"
                  name="edit_certification_name"
                  placeholder="Enter Certification Name"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('edit_certification_name', 'required')" class="margin-bottom-5 validate-warning-msg">Certification Name is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="edit_certificate_organization"
                  name="edit_certificate_organization"
                  placeholder="Certificate Organization"
                  class="col-lg-12 input-height-25 input-class"
                  v-validate="'required'"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('edit_certificate_organization', 'required')" class="margin-bottom-5 validate-warning-msg">Certificate Organization is required</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding" style="display:flex;">
            <div 
              class="search-padd" 
              id="affliate-wrapper" 
              style="height: 30px;width: 100%;">
              <multiselect v-model="edit_affiliate"
                :options="affiliate_options"
                track-by="value"
                label="text"
                placeholder="Select Affiliate"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                v-bind:name="'edit_affiliate[]'"
                v-bind:id="'affiliate'"
                v-validate="'required'">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              </multiselect>
            </div>
          </div>
          <div v-if="verrors.firstByRule('edit_affiliate[]', 'required')" class="validate-warning-msg" style="margin-top: 15px;">Affiliate is required</div>
          <div v-else class="validate-warning-msg" style="margin-top: -5px;">&nbsp;</div>
          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <input v-model="edit_certification_link"
                  name="edit_certification_link"
                  placeholder="Certification Link or Registration Link"
                  class="col-lg-12 input-height-25 input-class"
                  maxlength="255" />
            <div v-if="verrors.firstByRule('edit_certification_link')" class="margin-bottom-5 validate-warning-msg">Link is invalid</div>
          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>

          <div class="col-12 override-padding" v-if="(edit_image_flag == 1)">
            <input 
              @change="handleEditImage"
              type="file" 
              name="edit_image_file"
              ref="edit_image_file"
              v-validate="'required'"
              accept="image/*"
              rules="required"
              class="input-file" >
            <div v-if="verrors.firstByRule('edit_image_file', 'required')" class="margin-bottom-5 validate-warning-msg">Logo is required</div>
            <div class="help-text" >Logo should be jpg, jpeg, gif, png and size should be of 2MB</div>
            <div style="clear: both;" class="margin-bottom-10"></div>
          </div>
          <div class="col-12 override-padding" v-else>
            <button
              v-on:click="RemoveImage()"
              class="btn btn-red btn-md input-height-15 col-4"
              style="height: 30px;"
              ><b>Remove Image</b></button>
          </div>

          <div style="clear: both;" class="margin-bottom-10"></div>
          <div class="col-12 override-padding">
            <div class="col-9 float-left p-0 text-center" style="border: 1px solid #707070; height: 100px; width: 250px;" v-if="edit_image">
              <img :src="edit_image" width="100" height="85" style=" padding-top: 10px;" />
            </div>
            <div class="col-9 float-left p-0" style="border: 1px solid #707070; height: 100px; width: 250px; text-align: center; padding-top: 35px !important;"  v-else>
              Logo Example
            </div>
            <div class="col-3 text-align-right float-right p-0" style="margin-right: 0px; margin-top: 60px;">
              <button
                  v-on:click="editCertificate()"
                  class="btn btn-red col-lg-12 input-height-25 createBtn"
                  ><b>Save</b></button>

            </div>            
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </EditCertificateModal>


      <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to delete the certificate?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deleteCertificate(id)">Confirm</button>
        </div>
      </DeleteModal>

      <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to deactivate the certificate? </div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="showingdeleteModal = false; deactivateCertificate(deactivateId)">Confirm</button>
        </div>
      </DeactivateModal>

    <ActivateModal :isModalVisible="isActivateModalVisible" :id="activateId"  @close="isActivateModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to Activate? </div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="activateTasklist(activateId)">Confirm</button>
      </div>
    </ActivateModal>



      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import CreateCertificateModal from '../admin/create-tasklist-modal.vue';
import EditCertificateModal from '../admin/create-tasklist-modal.vue';
import router from '../../router/index.js';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import ActivateModal from '../shared/delete_modal_alert.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import Multiselect from 'vue-multiselect';
import CheckTasklistValidationModal from '../shared/validation_modal_alert.vue';


Vue.use(VeeValidate, { errorBagName: 'vverrors', fieldsBagName: 'vfields'});

export default {
        data() {
          return {
            filterFlag: false,
            rows: 0,
            perPage: 25,
            currentPage: 1,
            privateCurrentPage: 1,
            privateRows: 0,
            search_status: '',
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            certification_lists: [],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            loading: false,
            privateLoading: false,
            isModalVisible: false,
            certification_name: '',
            certificate_organization: '',
            certification_link: '',
            showOverlay: false,
            id: '',
            deactivateId: '',
            activateId: '',
            isDeleteModalVisible: false,
            isDeactivateModalVisible: false,
            isDeactivateValidateModalVisible: false,
            isActivateModalVisible: false,
            selectedComponent: 'Public',
            publicSortField: 'certificateName',
            publicSortBy: 'ASC',
            affiliate_options: [],
            search_affiliate: '',
            affiliate: [],
            tasklistTitle: '',
            image: '',
            isEditModalVisible: false,
            edit_certification_name: '',
            edit_certificate_organization: '',
            edit_certification_link: '',
            edit_affiliate: [],
            edit_image: '',
            edit_image_flag: 0,
            search_user: '',
            user_options: [],
          }
        },

        components: {
          UserMenu,
          GoBack,
          CreateCertificateModal,
          EditCertificateModal,
          DeleteModal,
          DeactivateModal,
          ActivateModal,
          MasteradminSidebarMenu,
          AdminSidebarMenu,
          Multiselect,
          CheckTasklistValidationModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            RemoveImage() {
              this.edit_image_file = '';
              this.edit_image = '';
              this.edit_image_flag = 1;
            },
            handleImage(e) {
              var selectedImage = e.target.files[0];
              this.createBase64Image(selectedImage);
            },
            handleEditImage(e) {
              var selectedImage = e.target.files[0];
              this.createEditBase64Image(selectedImage);
              this.edit_image_flag = 1;
            },
            createBase64Image(fileObject){
              const reader = new FileReader();
              reader.onload = (e) => {
                this.image = e.target.result;
              };
              reader.readAsDataURL(fileObject);
            },
            createEditBase64Image(fileObject){
              const reader = new FileReader();
              reader.onload = (e) => {
                this.edit_image = e.target.result;
              };
              reader.readAsDataURL(fileObject);
            },

            getCertificationDetails(certId) {
              axios.get('/get-certification-details/' + certId)
              .then((resp) => {
                this.certId = certId;
                this.isEditModalVisible = true;
                this.edit_certification_name = resp.data.cert.certification_name;
                this.edit_certificate_organization = resp.data.cert.certification_organization;
                this.edit_certification_link = resp.data.cert.certification_link;
                this.edit_affiliate = resp.data.cert.affiliate;
                this.edit_image = resp.data.cert.certification_logo;
                this.edit_image_file = '';
                this.edit_image_flag = 0;
              })
              .catch(error => {

              });

            },




            isActive: function (tabvalue) {
                 return this.selectedComponent === tabvalue
            },
            selected_component: function (tabvalue) {
               this.selectedComponent = tabvalue;
               this.search_status = '';
               let page_url = 'Tasklists';
               let active_tab = tabvalue;
               store.dispatch('active_tab', { page_url, active_tab })
               this.filterCertificationitems();
            },
            doEditValidate: function() {
              var vflag = 1;
              if(this.edit_certification_link != '') {
                if(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm.test(this.edit_certification_link)) {
                  
                }
                else {
                  alert("Please enter a valid certification link");
                  vflag = 0;
                  return false;
                }
              }
              if(this.edit_image == '') {
                alert("Please upload Image");
                vflag = 0;
                return false;
              }
              else {
                if(this.edit_image_flag == 1) {
                  if((this.$refs.edit_image_file.files[0].type != 'image/jpeg') && (this.$refs.edit_image_file.files[0].type != 'image/jpg') && (this.$refs.edit_image_file.files[0].type != 'image/png') && (this.$refs.edit_image_file.files[0].type != 'image/gif')) {
                    alert("Image should be of jpeg, jpg, png, gif formats only");
                    vflag = 0;
                    return false;
                  }
                  else if(this.$refs.edit_image_file.files[0].size > 2000000) {
                    alert("Image size should be of 2 MB only");
                    vflag = 0;
                    return false;
                  }
                }
              }
              return vflag;
            },
            editCertificate() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                var vflag = this.doEditValidate();
                if(vflag == 1) {
                  axios('/certification-manager/' + this.certId,
                     {
                       method: 'PATCH',
                       data:
                        {
                          certificate_name: this.edit_certification_name,
                          certificate_organization: this.edit_certificate_organization,
                          link: this.edit_certification_link,
                          affiliate_selected: this.edit_affiliate,
                          image: this.edit_image,
                        },
                     }
                   )
                  .then((resp) => {
                      this.edit_certification_name = '';
                      this.edit_certificate_organization = '';
                      this.edit_certification_link = '';
                      this.edit_image = '';
                      this.edit_affiliate = [];
                      this.isEditModalVisible = false;
                      this.fetchCertificationitems();
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

                }
                }
              })
              .catch(() => {

              });
            },

            doValidate: function() {
              var vflag = 1;
              if(this.certification_link != '') {
                if(/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm.test(this.certification_link)) {
                  
                }
                else {
                  alert("Please enter a valid certification link");
                  vflag = 0;
                  return false;
                }
              }
              if(this.image == '') {
                alert("Please upload Image");
                vflag = 0;
                return false;
              }
              else if(this.$refs.image_file.files[0].size > 2000000) {
                  alert("Image size should be of 2 MB only");
                  vflag = 0;
                  return false;
              }
              else {
                if((this.$refs.image_file.files[0].type != 'image/jpeg') && (this.$refs.image_file.files[0].type != 'image/jpg') && (this.$refs.image_file.files[0].type != 'image/png') && (this.$refs.image_file.files[0].type != 'image/gif')) {
                  alert("Image should be of jpeg, jpg, png, gif formats only");
                  vflag = 0;
                  return false;
                  }
              }
              return vflag;
            },
            createCertificate() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                var vflag = this.doValidate();
                if(vflag == 1) {
                  axios('/certification-manager',
                     {
                       method: 'POST',
                       data:
                        {
                          certificate_name: this.certification_name,
                          certificate_organization: this.certificate_organization,
                          certificate_link: this.certification_link,
                          affiliate_selected: this.affiliate,
                          image: this.image,
                        },
                     }
                   )
                  .then((resp) => {
                      this.certification_name = '';
                      this.certificate_organization = '';
                      this.certification_link = '';
                      this.image = '';
                      this.affiliate = [];
                      this.isModalVisible = false;
                      this.fetchCertificationitems();
                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });
                }
                }
              })
              .catch(() => {

              });
            },
            toggleDropdown (id) {
                document.getElementById(id).classList.toggle("show");
            },
            showTasklistofPaginated() {
               this.fetchCertificationitems();
               this.filterFlag = false;
            },
            filterCertificationitems() {
               this.filterFlag = true;
               this.fetchCertificationitems();
            },
            fetchCertificationitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_user) {
                params.search_user = this.search_user
              }
              if (this.search_keyword) {
                params.name = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_affiliate) {
                params.affiliate = this.search_affiliate
              }
              if (this.publicSortField) {
                params.sortfield = this.publicSortField
              }
              if (this.publicSortBy) {
                params.sortby = this.publicSortBy
              }
              axios.get('/certification-manager', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.certification_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            fetchUserOptions: function() {
             axios.get('/masteradmin-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: 'Created By'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });
           },
            goToEdit(id) {
               let title = 'Edit';
            },
            updateCertificateStatus(id, status_text) {
              this.showOverlay = true;
              axios('/certification-manager/' + id,
               {
                 method: 'PATCH',
                 data: { "status": status_text},
               }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchCertificationitems();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
           },
           cloneTasklist(tasklist_id) {
             this.showOverlay = true;
             axios('/clone-tasklist/' + tasklist_id,
              {
                method: 'POST',
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               store.dispatch('subtasks', '');
               router.push("/create-sub-tasklists/" + resp.data);
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
           },
           activateTasklistConfirm(tasklist_id) {
             this.isActivateModalVisible = true;
             this.activateId = tasklist_id;
           },
           activateTasklist(tasklist_id) {
             this.isActivateModalVisible = false;
             this.showOverlay = true;
             axios('/tasklist/' + tasklist_id,
              {
                method: 'PATCH',
                data: { "status": 'PUBLISH'},
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               this.fetchCertificationitems();
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
          },
           deactivateCertificateConfirm(id, tasklist_name) {
                   this.isDeactivateModalVisible = true;
                   this.deactivateId = id;
           },
           deactivateCertificate(id) {
             this.isDeactivateModalVisible = false;
             this.showOverlay = true;
             axios('/certification-manager/' + id,
              {
                method: 'PATCH',
                data: { "status": 'DEACTIVATED'},
              }
             )
             .then((resp) => {
               this.showOverlay = false;
               this.fetchCertificationitems();
             })
             .catch(error => {
                 if(error.response.data.message == 'Access denied.') {
                   router.push("/forbidden");
                 }
             });
          },
          hideActionMenu(e) {
             var matches = document.getElementsByClassName('dropdown-content');
             for (var i=0; i<matches.length; i++) {
               var container = document.getElementById('dropdown-container'+ i);

               if (!container.contains(e.target)) {
                    if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                       document.getElementById('actionDropdown' + i).classList.remove('show');
                    }
               }
             }
           },
           getStatus: function(status) {
             var status_val = this.status_options.findIndex(item => item.value === status);
             return this.status_options[status_val].text;
           },
           deleteCertificateConfirm: function(id) {
             this.isDeleteModalVisible = true;
             this.id = id;
           },
           deleteCertificate: function(id) {
             this.isDeleteModalVisible = false;
             this.showOverlay = true;
             axios('/certification-manager/' + id,
                {
                  method: 'DELETE',
                }
              )
             .then((resp) => {
                 this.showOverlay = false;
                 this.fetchCertificationitems();
              })
             .catch(error => {

             });
           },
           previewTaskList(tasklist_id) {
              router.push("/tasklist-preview/"+tasklist_id);
           },
           sortMethod: function(field) {
             this.publicSortField = field;
             if(this.publicSortBy == 'ASC') {
               this.publicSortBy = 'DESC';
             }
             else {
               this.publicSortBy = 'ASC';
             }
             this.fetchCertificationitems();
           },
           sortPrivateMethod: function(field) {
             this.privateSortField = field;
             if(this.privateSortBy == 'ASC') {
               this.privateSortBy = 'DESC';
             }
             else {
               this.privateSortBy = 'ASC';
             }
             this.fetchPrivateTasklistitems();
           },
           fetchAffiliateOptions: function() {
             axios.get('/affiliateoptions', {

             })
             .then((response) => {
                 var affiliate_option = {value: '', text: 'Select Affiliate'};
                 this.affiliate_options.push(affiliate_option);
                 for(var i=0; i < response.data.length; i++) {
                   var affiliate_option = {value: response.data[i].id, text: response.data[i].name};
                   this.affiliate_options.push(affiliate_option);
                 }
             })
             .catch(error => {

             });

           },
            scrollToElement(type) {
             const el = this.$el.getElementsByClassName('page_to_'+type)[0];
              if (el) {
                el.scrollIntoView({behavior: 'smooth'});
              }
            }
          },
         mounted() {
            document.addEventListener('click', this.hideActionMenu);
         },
         beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
         },
         created() {
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           this.fetchUserOptions();
           this.fetchCertificationitems();
           if((this.masterAdmin === true) && ((!store.state.switch_admin_username) || (store.state.switch_admin_username == ''))) {
            this.fetchAffiliateOptions();
           }
         }
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
*, *::before, *::after {
  outline: none;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.createBtn {
  margin: 10px 0 3px 5px;
}
.scroll_box {
  padding: 0;
  display: flex;
  justify-content: end;
}
.scroll_up_down {
  background-color: #efac91;
  padding: 5px;
  text-align: center;
  width: 40px;
}
.angle_font {
  color: #FFF !important;
  font-size: 1.8rem !important;
}
.page_angle_down { margin: 10px 15px; }
.input-class {
  border: 1px solid #767676;
}
</style>
<style>
#affliate-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#affliate-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
#affliate-wrapper .multiselect {
  border: 1px solid #767676;
  width: 99.33%;
}
#affliate-wrapper .multiselect__tags {
  padding: 8px 40px 0 15px;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}
.dropbtn {
  color: #000;
}
.modal-header h3 {
  color: #002F42;
  font-size: 16px;
  font-weight: bold;
}
.modal-header .sub-heading {
  margin-left: 5px;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/view_certification_manager.vue